import * as $runtime from "../runtime.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Restaumatic$dCurrencies from "../Restaumatic.Currencies/index.js";
import {_formatCurrency} from "./foreign.js";
const currencyOptions = v => {
  if (v.tag === "PLN") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "zł"}; }
  if (v.tag === "CZK") { return {format: "%n %u", precision: 2, separator: ",", delimiter: "", unit: "Kč"}; }
  if (v.tag === "GBP") { return {format: "%u%n", precision: 2, separator: ".", delimiter: ",", unit: "£"}; }
  if (v.tag === "USD") { return {format: "%u%n", precision: 2, separator: ".", delimiter: "", unit: "$"}; }
  if (v.tag === "EUR") { return {format: "%n %u", precision: 2, separator: ",", delimiter: "", unit: "EUR"}; }
  if (v.tag === "RUB") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "руб."}; }
  if (v.tag === "RON") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "RON"}; }
  if (v.tag === "HRK") { return {format: "%n %u", precision: 2, separator: ",", delimiter: " ", unit: "kn"}; }
  if (v.tag === "BRL") { return {format: "%u%n", precision: 2, separator: ".", delimiter: "", unit: "R$"}; }
  if (v.tag === "RSD") { return {format: "%n %u", precision: 2, separator: ",", delimiter: ".", unit: "рсд"}; }
  $runtime.fail();
};
const currencyUnit = x => currencyOptions(x).unit;
const formatCurrencyFormal = currency => value => _formatCurrency(
  {...currencyOptions(currency), format: "%u %n", unit: Restaumatic$dCurrencies.showCurrency.show(currency)},
  Data$dInt.toNumber(value) / 100.0
);
const formatCurrencySimple = currency => value => _formatCurrency(currencyOptions(currency), Data$dInt.toNumber(value) / 100.0);
const formatCurrency = formatCurrencySimple;
const formatCurrencyWithoutUnit = currency => value => _formatCurrency({...currencyOptions(currency), unit: ""}, Data$dInt.toNumber(value) / 100.0);
export {currencyOptions, currencyUnit, formatCurrency, formatCurrencyFormal, formatCurrencySimple, formatCurrencyWithoutUnit};
export * from "./foreign.js";
